import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "@reducers/rootReducer";

const deepClone = (obj: any) => JSON.parse(JSON.stringify(obj));

const paramsSerializer = (params: any) => {
  const clonedParams = params ? deepClone(params) : {};
  const searchParams = new URLSearchParams();

  if (clonedParams?.page) {
    for (const [key, value] of Object.entries(clonedParams.page)) {
      searchParams.set(`page[${key}]`, String(value));
    }
    delete clonedParams.page;
  }
  if (clonedParams?.include && Array.isArray(clonedParams.include)) {
    searchParams.set("include", clonedParams.include.join(","));
    delete clonedParams.include;
  }
  if (clonedParams?.sort && Array.isArray(clonedParams.sort)) {
    searchParams.set("sort", clonedParams.sort.join(","));
    delete clonedParams.sort;
  }

  if (clonedParams) {
    for (const [key, value] of Object.entries(clonedParams)) {
      if (value && typeof value === "object") {
        for (const [subKey, subValue] of Object.entries(value)) {
          searchParams.set(`${key}[${subKey}]`, subValue as string);
        }
      } else {
        searchParams.set(key, value as string);
      }
    }
  }

  return searchParams.toString();
};

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_SCOPESTACK_API_HOST as string,
  prepareHeaders: (headers: Headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    headers.set("Content-Type", "application/vnd.api+json");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
  paramsSerializer,
});

export const scopeStackApiV2 = createApi({
  reducerPath: "scopeStackApiV2",
  baseQuery,
  endpoints: () => ({}),
});
